export const CHATBOT_STATUS_PENDING = 'pending'
export const CHATBOT_STATUS_CONNECTED = 'connected'
export const CHATBOT_STATUS_DISCONNECTED = 'disconnected'
